import { Avatar, Badge } from '@mui/material';
import { BadgeProps } from '@mui/material/Badge/Badge';

import { theme } from '~/theme';

export const ProcessItemBadge = (
  props: BadgeProps & {
    disabled?: boolean;
  },
) => {
  const { children, disabled, ...restProps } = props;

  const badgeProps: BadgeProps = {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
    sx: {
      '& .MuiBadge-badge': {
        boxShadow: theme.shadows[1],
        ...(disabled
          ? {
              backgroundColor: theme.palette.action.disabledBackground,
              color: theme.palette.action.disabled,
            }
          : {}),
      },
    },
    ...restProps,
  };

  return (
    <Badge {...badgeProps}>
      <Avatar
        sx={{
          backgroundColor: '#fff',
          boxShadow: theme.shadows[1],
        }}
      >
        {children}
      </Avatar>
    </Badge>
  );
};
